'use strict';

var isEffect = function isEffect(maybeEffect) {
  return maybeEffect != null && typeof maybeEffect.run === 'function' && typeof maybeEffect.isQueued === 'boolean' && (!maybeEffect.resultActionCreator || typeof maybeEffect.resultActionCreator === 'function');
};

var isImmediateEffect = function isImmediateEffect(maybeEffect) {
  return isEffect(maybeEffect) && !maybeEffect.isQueued;
};

var isQueuedEffect = function isQueuedEffect(maybeEffect) {
  return isEffect(maybeEffect) && maybeEffect.isQueued;
};

module.exports = {
  isEffect: isEffect,
  isImmediateEffect: isImmediateEffect,
  isQueuedEffect: isQueuedEffect
};